import { querySelectorURL } from "../../cpcoc/querySelectorURL";
import { randomNum } from "../../cpcoc/randomNum";
const pageId = String(querySelectorURL("pageId") || randomNum(100, 999));
export function getPageId() {
    return pageId;
}
